import { Product } from './product.model';

export interface OrderInsightData {
  orderInsightType: OrderInsightsType;
  product: Product;
  lastOrderedDate?: string | Date;
  casesAndEachesOrdered?: string;
}

export enum OrderInsightsType {
  LostLines = 'LOST LINES',
  NewProductsOrdered = 'NEW PRODUCTS ORDERED',
}
